<template>
  <div class="inventory-records-container">

    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="searchForm" class="filter-form">
        <el-form-item label="商品名称">
          <el-input
            v-model="searchForm.goods_name"
            placeholder="请输入商品名称"
            clearable
            @keyup.enter.native="handleSearch"
            style="width: 200px;"
          />
        </el-form-item>
        <el-form-item label="发生时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
            style="width: 260px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" icon="el-icon-refresh" @click="refreshData">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计区域 -->
    <!-- <el-row :gutter="20" class="stat-row">
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row> -->

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        border
        stripe
        style="width: 100%"
        max-height="570"
      >
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="comlist_v1" label="商品名" min-width="150" show-overflow-tooltip />
        <el-table-column prop="pici" label="批次" min-width="130" show-overflow-tooltip />
        <el-table-column prop="comlist_s1" label="数量" width="130" align="right">
          <template slot-scope="scope">
            <span class="number-cell">{{ formatQuantity(scope.row.comlist_s1) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist3" label="发生时间" min-width="170" />
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleViewDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      title="库存动态明细"
      :visible.sync="detailDialogVisible"
      width="70%"
      :close-on-click-modal="true"
      @close="handleDialogClose"
    >
      <div class="detail-dialog-header" v-if="currentDetailRow">
        <el-descriptions :column="4" border size="small">
          <el-descriptions-item label="商品名">
            {{ currentDetailRow.comlist_v1 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="批次">
            {{ currentDetailRow.pici || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="总数量">
            <span class="number-cell">{{ formatQuantity(currentDetailRow.comlist_s1) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="发生时间">
            {{ currentDetailRow.comlist3 || '--' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <el-table
        v-loading="detailLoading"
        :data="detailList"
        border
        stripe
        style="width: 100%; margin-top: 12px;"
        max-height="400"
      >
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="comlist_v1" label="商品名" min-width="150" show-overflow-tooltip />
        <el-table-column prop="type" label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === '入库' ? 'success' : 'warning'" size="small">
              {{ scope.row.type || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_s1" label="数量" width="130" align="right">
          <template slot-scope="scope">
            <span class="number-cell">{{ formatQuantity(scope.row.comlist_s1) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist3" label="发生时间" min-width="180" />
      </el-table>

      <div class="detail-footer" v-if="detailList.length > 0">
        <span>共 {{ detailList.length }} 条明细</span>
      </div>
      <div v-else-if="!detailLoading" class="detail-empty">暂无明细数据</div>

      <span slot="footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'InventoryRecords',
  data () {
    const today = new Date()
    const oneMonthAgo = new Date(today)
    oneMonthAgo.setMonth(today.getMonth() - 1)

    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return {
      // 列表数据
      loading: false,
      list: [],
      total: 0,
      page: 1,
      limit: 20,

      // 筛选表单
      searchForm: {
        goods_name: '',
        start_time: formatDate(oneMonthAgo),
        end_time: formatDate(today)
      },
      dateRange: [formatDate(oneMonthAgo), formatDate(today)],

      // 详情弹窗
      detailDialogVisible: false,
      detailLoading: false,
      detailList: [],
      currentDetailRow: null
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    // ----- 列表数据请求 -----
    async fetchData () {
      this.loading = true
      try {
        const shopId = localStorage.getItem('currentShopId') || localStorage.getItem('sh_id')

        if (!shopId) {
          this.$message.warning('请先选择店铺')
          this.loading = false
          return
        }

        const params = {
          sh_id: parseInt(shopId),
          page: this.page,
          page_size: this.limit,
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time
        }

        if (this.searchForm.goods_name && this.searchForm.goods_name.trim() !== '') {
          params.goods_name = this.searchForm.goods_name.trim()
        }

        const res = await request.post('/goods/kucun_display.php?a=inventory', params)

        if (res && res.code === '0') {
          this.list = res.data || []
          this.total = parseInt(res.goods_num) || 0
        } else {
          this.$message.error(res?.msg || '获取动态记录失败')
          this.list = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求异常:', error)
        this.$message.error('网络错误，请稍后重试')
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // ----- 获取明细数据 -----
    async fetchDetail (row) {
      this.detailLoading = true
      try {
        const shopId = localStorage.getItem('currentShopId') || localStorage.getItem('sh_id')

        if (!shopId) {
          this.$message.warning('请先选择店铺')
          this.detailLoading = false
          return
        }

        const params = {
          sh_id: parseInt(shopId),
          pici: row.pici || '',
          goods_id: row.goods_id || '',
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time
        }

        const res = await request.post('/goods/kucun_display.php?a=changeHistory', params)

        if (res && res.code === '0') {
          this.detailList = res.data || []
        } else {
          this.$message.error(res?.msg || '获取明细数据失败')
          this.detailList = []
        }
      } catch (error) {
        console.error('明细请求异常:', error)
        this.$message.error('网络错误，请稍后重试')
        this.detailList = []
      } finally {
        this.detailLoading = false
      }
    },

    // ----- 查看详情 -----
    handleViewDetail (row) {
      this.currentDetailRow = row
      this.detailList = []
      this.detailDialogVisible = true
      this.fetchDetail(row)
    },

    // ----- 关闭弹窗 -----
    handleDialogClose () {
      this.detailList = []
      this.currentDetailRow = null
      this.detailLoading = false
    },

    // ----- 搜索 / 重置 / 刷新 -----
    handleSearch () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.searchForm.start_time = this.dateRange[0]
        this.searchForm.end_time = this.dateRange[1]
      } else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
      this.page = 1
      this.fetchData()
    },

    handleReset () {
      const today = new Date()
      const oneMonthAgo = new Date(today)
      oneMonthAgo.setMonth(today.getMonth() - 1)

      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      this.searchForm.goods_name = ''
      this.searchForm.start_time = formatDate(oneMonthAgo)
      this.searchForm.end_time = formatDate(today)
      this.dateRange = [formatDate(oneMonthAgo), formatDate(today)]
      this.page = 1
      this.fetchData()
    },

    refreshData () {
      this.fetchData()
    },

    // ----- 分页 -----
    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.fetchData()
    },

    handleCurrentChange (val) {
      this.page = val
      this.fetchData()
    },

    // ----- 格式化工具 -----
    formatQuantity (val) {
      if (val === undefined || val === null || val === '') return '0'
      if (val === '--') return '--'
      const num = Number(val)
      return isNaN(num) ? val : num.toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory-records-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .page-header {
    padding: 16px 0 8px 0;

    h2 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: #303133;
      letter-spacing: 1px;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 22px;
        background: #409eff;
        border-radius: 2px;
        margin-right: 12px;
        vertical-align: middle;
      }
    }
  }

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;

      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .stat-row {
    margin-bottom: 20px;

    .stat-card {
      .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;

        .stat-label {
          font-size: 15px;
          color: #606266;
        }

        .stat-value {
          font-size: 26px;
          font-weight: 700;
          color: #303133;
        }
      }
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }

    .number-cell {
      font-weight: 500;
      color: #409eff;
    }
  }

  // 详情弹窗样式
  .detail-dialog-header {
    margin-bottom: 16px;

    ::v-deep .el-descriptions {
      .el-descriptions__body {
        .el-descriptions__table {
          .el-descriptions__cell {
            padding: 8px 12px;
          }
        }
      }
    }
  }

  .detail-footer {
    padding: 12px 0 4px 0;
    text-align: right;
    font-size: 14px;
    color: #909399;
  }

  .detail-empty {
    padding: 30px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
}
</style>
